var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { makeStyles } from '@material-ui/core/styles';
import { Button } from '@material-ui/core';
const useStyles = makeStyles(({ palette }) => ({
    text: {
        textTransform: 'none',
        color: palette.primary.contrastText,
    },
    startIcon: {
        fill: palette.primary.contrastText,
    },
}));
const Container = styled.li `
  display: flex;
  align-items: center;
`;
const Item = (_a) => {
    var { className, children, icon } = _a, rest = __rest(_a, ["className", "children", "icon"]);
    const classes = useStyles();
    return (React.createElement(Container, { className: className },
        React.createElement(Button, Object.assign({ classes: {
                startIcon: classes.startIcon,
                text: classes.text,
            }, startIcon: icon }, rest), children)));
};
Item.displayName = 'Footer.Item';
Item.propTypes = {
    icon: PropTypes.node,
};
const ItemExtra = styled(Item) ``;
export default ItemExtra;
